import { render } from "./AccountRejected.vue?vue&type=template&id=de08ea82"
import script from "./AccountRejected.vue?vue&type=script&lang=js"
export * from "./AccountRejected.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__